// Copyright: IQGeo Limited 2010-2019
import L from 'leaflet';
import myw from 'myWorld/base/core';
import 'leaflet-plugins/layer/vector/KML';

L.KML.prototype.loadXML = function(url, cb, options, async) {
    if (async === undefined) async = this.options.async;
    if (options === undefined) options = this.options;

    const req = new window.XMLHttpRequest();

    // Check for IE8 and IE9 Fix Cors for those browsers
    if (req.withCredentials === undefined && typeof window.XDomainRequest !== 'undefined') {
        const xdr = new window.XDomainRequest();
        xdr.open('GET', url, async);
        xdr.onprogress = () => {};
        xdr.ontimeout = () => {};
        xdr.onerror = () => {};
        xdr.onload = () => {
            if (xdr.responseText) {
                const xml = new window.ActiveXObject('Microsoft.XMLDOM');
                xml.loadXML(xdr.responseText);
                cb(xml, options);
            }
        };
        setTimeout(() => {
            xdr.send();
        }, 0);
    } else {
        req.open('GET', url, async);
        req.setRequestHeader('Accept', 'application/vnd.google-earth.kml+xml');
        try {
            req.overrideMimeType('application/xml'); // unsupported by IE
        } catch (e) {
            console.log(e);
        }
        req.onreadystatechange = () => {
            if (req.readyState !== 4) return;
            let res = null;
            if (req.responseXML) {
                res = req.responseXML;
            } else {
                const parser = new DOMParser();
                res = parser.parseFromString(req.response, 'text/xml');
                //options.onError('KML is not valid');
                //return;
            }
            if (req.status === 200) {
                cb(res, options);
                return;
            }
            options.onError(`Error fetching kml ${req.status}`);
        };
        req.send(null);
    }
};

/*
 *  Remove default popup behaviour
 */
const parsePlacemark = L.KML.parsePlacemark.bind(L.KML);

L.KML.parsePlacemark = (place, xml, style, options) => {
    let layer = parsePlacemark(place, xml, style, options);
    if (!layer) return;

    const elName = place.getElementsByTagName('name')[0];
    const name = elName && elName.innerHTML;
    const elSnippet = place.getElementsByTagName('Snippet')[0];
    const snippet = (elSnippet && elSnippet.innerHTML) || '';
    const elDescription = place.getElementsByTagName('description')[0];
    const description = (elDescription && elDescription.innerHTML) || null;
    const elData = place.getElementsByTagName('Data');
    const elSimpleData = place.getElementsByTagName('SimpleData');
    const elDataArray = [].slice.call(elData);
    const elSimpleDataArray = [].slice.call(elSimpleData);

    layer.properties = {};
    layer.properties.name = name || snippet || 'Placemark';
    layer.properties.description = description;

    layer.properties = elDataArray.reduce((acc, node) => {
        const value = node.getElementsByTagName('value')[0];
        if (value && value.innerHTML != 'null') {
            acc[node.getAttribute('name')] = value.innerHTML;
        }
        return acc;
    }, layer.properties);

    layer.properties = elSimpleDataArray.reduce((acc, node) => {
        acc[node.getAttribute('name')] = node.innerHTML;
        return acc;
    }, layer.properties);

    layer.on('add', layer.unbindPopup);

    return layer;
};

/*
 * Modified so that two SVGs are created, one with a larger weight than the other. Then link the two together
 */
L.KML.parseKML = function(xml) {
    const style = this.parseStyles(xml);
    const style2 = JSON.parse(JSON.stringify(style));
    _.each(style2, styleList => {
        if ('weight' in styleList) {
            styleList.weight = 10;
        }

        if ('opacity' in styleList) {
            styleList.opacity = 0;
        }
    });
    this.parseStyleMap(xml, style);
    let el = xml.getElementsByTagName('Folder');
    const layers = [];
    let l;
    let l2;
    for (let i = 0; i < el.length; i++) {
        if (!this._check_folder(el[i])) {
            continue;
        }
        l = this.parseFolder(el[i], style);
        if (l) {
            layers.push(l);
        }
    }
    el = xml.getElementsByTagName('Placemark');
    for (let j = 0; j < el.length; j++) {
        if (!this._check_folder(el[j])) {
            continue;
        }
        l = this.parsePlacemark(el[j], xml, style);
        l2 = this.parsePlacemark(el[j], xml, style2);
        if (l && l2) {
            l2.mywOrigObj = l;
            layers.push(l);
            layers.push(l2);
        }
    }
    el = xml.getElementsByTagName('GroundOverlay');
    for (let k = 0; k < el.length; k++) {
        l = this.parseGroundOverlay(el[k]);
        if (l) {
            layers.push(l);
        }
    }
    return layers;
};

/*
 * Modified so that if mywOrigObj is set on a target, return that instead. This is used in
 * conjunction with the above function to add a larger hitbox to KML paths
 */
L.Map.prototype._findEventTargets = function(e, type) {
    let targets = [];
    let target;
    const isHover = type === 'mouseout' || type === 'mouseover';
    let src = e.target || e.srcElement;
    let dragging = false;

    while (src) {
        target = this._targets[L.Util.stamp(src)];
        if (target && target.mywOrigObj) {
            target = target.mywOrigObj;
        }
        if (
            target &&
            (type === 'click' || type === 'preclick') &&
            !e._simulated &&
            this._draggableMoved(target)
        ) {
            // Prevent firing click after you just dragged an object.
            dragging = true;
            break;
        }
        if (target && target.listens(type, true)) {
            if (isHover && !L.DomEvent.isExternalTarget(src, e)) {
                break;
            }
            targets.push(target);
            if (isHover) {
                break;
            }
        }
        if (src === this._container) {
            break;
        }
        src = src.parentNode;
    }
    if (!targets.length && !dragging && !isHover && L.DomEvent.isExternalTarget(src, e)) {
        targets = [this];
    }
    return targets;
};

/*
 * Fixes image alignment
 */
L.KMLIcon.prototype._setIconStyles = function(img, name) {
    L.Icon.prototype._setIconStyles.apply(this, [img, name]);

    img.onload = function(i) {
        this.height = 32;
        this.width = 32;
        this.style.marginLeft = `${-this.width / 2}px`;
        this.style.marginTop = `${-this.height / 2}px`;
    };
};

myw.KmlLayer = L.KML.extend({
    initialize(url, layerDef, datasource) {
        this.options = layerDef.options;
        this.layerDef = layerDef;
        this.datasource = datasource;

        //pass undefined as url to delay loading of kml until self is added onto a map

        L.KML.prototype.initialize.call(this, undefined, this.options);

        this.on('addlayer', ({ layer }) => {
            this.registerClickHandler(layer);
            this.registerClickHandlerOnLayers(layer._layers || {});
        });
        this._urlToLoad = url;
    },

    registerClickHandlerOnLayers(layers) {
        Object.keys(layers)
            .map(lId => layers[lId])
            .forEach(layer => {
                this.registerClickHandler(layer);
                this.registerClickHandlerOnLayers(layer._layers || {});
            });
    },

    registerClickHandler(layer) {
        let clazz = this.datasource._getFeatureClassFor('kml_entity');
        clazz.prototype.fieldViewers = { description: myw.HtmlFieldViewer };

        if (layer.properties && layer.properties.name) {
            let feature = this.datasource._asFeature(
                {
                    ...layer.toGeoJSON(),
                    id: layer.properties.name,
                    properties: layer.properties
                },
                'kml_entity',
                {}
            );

            feature.getTitle = () => layer.properties.name;

            layer.on('click', e => {
                if (feature) {
                    L.DomEvent.stop(e);
                    myw.app.setCurrentFeature(feature);
                }
            });
        }
    },

    onAdd(map) {
        this.options.onError = message => {
            this.fire('invalid');
        };

        if (this._urlToLoad) {
            this.addKML(this._urlToLoad, this.options, this.options.async);
            delete this._urlToLoad;
        }
        this.datasource.system.recordDataAccess(
            this.datasource.database.applicationName,
            `layer.${this.layerDef.name}`
        );
        return L.KML.prototype.onAdd.call(this, map);
    }
});

export default myw.KmlLayer;
